// Dynamic theme colors hook based on chart config
import { useMemo } from 'react';
import { useGoogleSheets } from '../context/GoogleSheetsContext';

// Default colors (Hot 100)
const DEFAULT_THEME_COLOR = '#00FF9A';

// Helper to darken a hex color for hover state
function darkenColor(hex: string, percent: number = 10): string {
  // Remove # if present
  hex = hex.replace('#', '');

  // Parse RGB values
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  // Darken each component
  const darken = (value: number) => Math.max(0, Math.floor(value * (1 - percent / 100)));

  // Convert back to hex
  const toHex = (value: number) => value.toString(16).padStart(2, '0');

  return `#${toHex(darken(r))}${toHex(darken(g))}${toHex(darken(b))}`;
}

export interface ThemeColors {
  themeColor: string;
  themeHoverColor: string;
}

export function useThemeColors(): ThemeColors {
  const { currentChartConfig } = useGoogleSheets();

  return useMemo(() => {
    const themeColor = currentChartConfig?.themeColor || DEFAULT_THEME_COLOR;
    return {
      themeColor,
      themeHoverColor: darkenColor(themeColor, 10),
    };
  }, [currentChartConfig?.themeColor]);
}
